import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import styles from '../../lib/global.css';
import Modal from "../../../containers/modal";
import bindAll from "lodash.bindall";
import {headNavBack} from '../../lib/utils'

/**
 * 页面组件，放在每个page的最外层，可以通过参数来控制页面外框
 * @param props
 * @returns {*}
 * @constructor
 */
class Page extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClose',
        ]);
    }

    handleClose() {
        headNavBack(this.props.history)
        // window.initState();
    }

    render() {
        return (
            <div className={styles.page}>
                {this.props.isModal ? (
                    <Modal
                        id="main-modal"
                        fullScreen
                        contentLabel={this.props.title}
                        onBackAction={this.handleClose}
                        headerClassName={styles.headerFixed}
                    >
                        {this.props.children}
                    </Modal>
                ) : this.props.children}
            </div>
        );
    }
}

Page.propTypes = {
    isModal: PropTypes.bool,
    title: PropTypes.string,
}

export default withRouter(Page);

